// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"fa271ec1","6897":"bc749f96","9767":"1ae102d7"}[chunkId] + ".chunk.css";
};